import { render, staticRenderFns } from "./add_edit.vue?vue&type=template&id=7153732f&scoped=true&"
import script from "./add_edit.vue?vue&type=script&lang=js&"
export * from "./add_edit.vue?vue&type=script&lang=js&"
import style0 from "./add_edit.vue?vue&type=style&index=0&id=7153732f&prod&lang=scss&"
import style1 from "./add_edit.vue?vue&type=style&index=1&id=7153732f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7153732f",
  null
  
)

export default component.exports